import React from "react";

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSquare, faCheckSquare } from '@fortawesome/free-regular-svg-icons'

const SemanticCheckbox = ({ label, checked, onChange, ...props }) => {
  return (
    <label className="flex justify-start items-center space-x-2" onClick={onChange}>
      {!checked && <FontAwesomeIcon icon={faSquare} className="text-2xl" />}
      {checked && <FontAwesomeIcon icon={faCheckSquare} className="text-2xl" />}
      <div className="select-none sm:text-base md:text-xl font-normal">{label}</div>
    </label>
  )
}
export default SemanticCheckbox
